import StripeNativePaymentButton from './StripeNativePaymentButton'
export { default as stripeNativePaymentElementsOptions } from './elementsOptions'
export default StripeNativePaymentButton
